module.exports = __webpack_public_path__ + "img/icon-data-diri.c26df11c.svg";